import React, { useState, useCallback, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { add, format, parseISO } from "date-fns";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles, alpha, useTheme } from "@material-ui/core/styles";
import {
  Button,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableContainer,
  TableHead,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
  Chip,
} from "@material-ui/core";
import {
  Edit,
  CheckCircle,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
  Sync,
  SwapHoriz,
  Replay,
  HeadsetMic,
  Add,
  ExpandMore,
  Forum,
} from "@material-ui/icons";
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import MainContainer from "../../components/MainContainer";

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import WhatsAppOficialWizard from "../../components/WhatsAppOficialWizard";
import AerosConfirmModal from "../../components/AerosConfirmModal";
import AerosDialog from "../../components/AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import QrcodeModal from "../../components/QrcodeModal";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import formatSerializedId from '../../utils/formatSerializedId';
import { AuthContext } from "../../context/Auth/AuthContext";
import { AEROS, stateText } from "../../styles/aerosTokens";
import usePlans from "../../hooks/usePlans";
import useMessages from "../../hooks/useMessages";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BotaoJaRegularizei from "../../components/BotaoJaRegularizei";
import { headerSubtitle, seloContaMeta } from "./connectionRules";
import ForbiddenPage from "../../components/ForbiddenPage";
import { Can } from "../../components/Can";

// Grid da tabela — espelha o mockup Conexões A:
// Canal | Cor | Nome | Número | Status | Sessão | Atualização | Padrão | Ações
const TABLE_GRID =
  "70px 70px 1.5fr 1.3fr 1.2fr 1.7fr 1.2fr 0.7fr 1.1fr";

const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  return {
  // ---- header da página (60px, título + subtítulo, ações à direita) ----
  pageHeader: {
    minHeight: 60,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "0 12px",
    borderBottom: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.06)"}`,
  },
  pageTitle: {
    fontFamily: AEROS.fontDisplay,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "-0.02em",
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
  pageTitleCount: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  pageSubtitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
  },
  headerActions: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  ghostButton: {
    border: `1px solid ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.14)"}`,
    borderRadius: 10,
    padding: "8px 14px",
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.primary,
    "& .MuiButton-startIcon .MuiSvgIcon-root": { fontSize: 17 },
  },
  superButton: {
    borderColor: "rgba(160,68,255,0.4)",
  },
  superBadge: {
    marginLeft: 6,
    fontSize: 9.5,
    fontWeight: 800,
    letterSpacing: "0.08em",
    borderRadius: 5,
    padding: "1px 5px",
    color: "#C08BFF",
    backgroundColor: "rgba(160,68,255,0.18)",
  },
  gradientButton: {
    borderRadius: 10,
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 700,
    "& .MuiSvgIcon-root": { fontSize: 17 },
  },
  // ---- corpo da página ----
  pageBody: {
    flex: 1,
    padding: "16px 12px",
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  // ---- card da tabela em CSS grid ----
  tableCard: {
    backgroundColor: theme.palette.aeros.surface,
    border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.07)"}`,
    borderRadius: 14,
    overflow: "hidden",
  },
  tableHeadRow: {
    display: "grid",
    gridTemplateColumns: TABLE_GRID,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.text.disabled || theme.palette.aeros.textTertiary,
    backgroundColor: isLight ? "rgba(15,20,40,0.02)" : "rgba(255,255,255,0.02)",
    borderBottom: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.08)"}`,
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: TABLE_GRID,
    alignItems: "center",
    fontSize: 13.5,
    fontVariantNumeric: "tabular-nums",
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.05)"}`,
    "&:last-child": { borderBottom: "none" },
    "&:hover": { backgroundColor: "rgba(160,68,255,0.04)" },
  },
  tableCell: {
    padding: "12px 8px",
    minWidth: 0,
  },
  cellCenter: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  cellActionsHead: {
    textAlign: "right",
    paddingRight: 20,
  },
  cellActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 6,
    paddingRight: 20,
  },
  cellSession: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
  },
  colorSwatch: {
    width: 28,
    height: 12,
    borderRadius: 4,
    display: "inline-block",
  },
  nameCell: {
    fontWeight: 600,
  },
  nameSub: {
    fontSize: 11,
    fontWeight: 500,
    color: theme.palette.aeros.textTertiary,
  },
  numberCell: {
    color: theme.palette.text.secondary,
  },
  updatedCell: {
    color: theme.palette.text.secondary,
    fontSize: 12.5,
  },
  defaultCheck: {
    color: theme.palette.success.main,
    "&.MuiSvgIcon-root": { fontSize: 19 },
  },
  channelIcon: {
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  loadingRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "28px 0",
  },
  statusCellInner: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
  },
  tooltip: {
    backgroundColor: theme.palette.aeros.surface2,
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(14),
    border: `1px solid ${theme.palette.divider}`,
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: "center",
  },
  buttonProgress: {
    color: theme.palette.success.main,
  },
  modalText: {
    fontSize: 12.5,
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
  },
  transferRow: {
    display: "grid",
    gridTemplateColumns: "minmax(0,1fr) auto minmax(0,1fr)",
    gap: 12,
    alignItems: "end",
  },
  transferArrow: {
    fontSize: 18,
    color: theme.palette.aeros.textTertiary,
    marginBottom: 9,
  },
  progressBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    textAlign: "center",
    padding: "8px 0",
  },
  progressPct: { fontSize: 14, fontWeight: 700, color: theme.palette.text.primary },
  progressCount: { fontSize: 13, color: theme.palette.text.primary },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px",
    borderRadius: 99,
    fontSize: 11,
    fontWeight: 600,
  },
  statusPillSuccess: {
    color: stateText(theme, theme.palette.success.main, "success"),
    backgroundColor: alpha(theme.palette.success.main, 0.1),
  },
  statusPillWarning: {
    color: stateText(theme, theme.palette.warning.main, "warning"),
    backgroundColor: alpha(theme.palette.warning.main, 0.1),
  },
  statusPillError: {
    color: stateText(theme, theme.palette.error.main, "error"),
    backgroundColor: alpha(theme.palette.error.main, 0.1),
  },
  contaMetaSelo: { whiteSpace: "normal", overflowWrap: "anywhere" },
  contaMetaLink: {
    display: "inline-flex", alignItems: "center", fontSize: 11.5, fontWeight: 700,
    color: stateText(theme, AEROS.warning, "warning"), textDecoration: "underline",
    "@media (pointer: coarse)": { minHeight: 44 },
  },
  statusDot: {
    width: 6,
    height: 6,
    flexShrink: 0,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  sessionButton: {
    padding: "5px 12px",
    fontSize: 11.5,
    fontWeight: 600,
    borderRadius: 8,
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  sessionButtonDestructive: {
    backgroundColor: alpha(theme.palette.error.main, 0.08),
    borderColor: alpha(theme.palette.error.main, 0.4),
    color: stateText(theme, theme.palette.error.main, "error"),
    "&:hover": {
      backgroundColor: alpha(theme.palette.error.main, 0.15),
      borderColor: alpha(theme.palette.error.main, 0.6),
    },
  },
  sessionButtonGhost: {
    borderColor: isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.16)",
    color: theme.palette.text.primary,
  },
  rowActionButton: {
    width: 30,
    height: 30,
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    padding: 0,
    "&:hover": {
      color: theme.palette.secondary.main,
      borderColor: "rgba(34,211,238,0.4)",
      backgroundColor: "transparent",
    },
    "& .MuiSvgIcon-root": { fontSize: 16 },
  },
  summaryCardsWrapper: {
    display: "flex",
    gap: 14,
    marginTop: 14,
    flexWrap: "wrap",
  },
  summaryCard: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    backgroundColor: theme.palette.aeros.surface,
    border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.07)"}`,
    borderRadius: 14,
    padding: "16px 20px",
    flex: "1 1 220px",
    boxShadow: "none",
  },
  summaryIcon: {
    width: 40,
    height: 40,
    borderRadius: 11,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  summaryIconSuccess: {
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    color: theme.palette.success.main,
  },
  summaryIconWarning: {
    backgroundColor: alpha(theme.palette.warning.main, 0.1),
    color: theme.palette.warning.main,
  },
  // Roxo do mockup (#C08BFF sobre tile rgba(160,68,255,0.12)); no claro usa o
  // par escurecido para manter contraste.
  summaryIconPurple: {
    backgroundColor: "rgba(160,68,255,0.12)",
    color: isLight ? AEROS.stateTextOnLight.purple : "#C08BFF",
  },
  summaryLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  summaryValue: {
    fontSize: 20,
    fontWeight: 700,
    fontVariantNumeric: "tabular-nums",
    marginTop: 2,
  },
  };
});

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color="inherit">
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel) => {
  switch (channel) {
    case "facebook":
      return <Facebook style={{ color: "#3b5998", fontSize: 20 }} />;
    case "instagram":
      return <Instagram style={{ color: "#e1306c", fontSize: 20 }} />;
    case "whatsapp":
      return <WhatsApp style={{ color: "#25d366", fontSize: 20 }} />;
    case "whatsapp_oficial":
      return <WhatsApp style={{ color: "#25d366", fontSize: 20 }} />;
    default:
      return "error";
  }
};

// Sublabel da coluna Nome — mesmo texto do mockup por tipo de canal.
const channelSublabel = (channel) => {
  switch (channel) {
    case "whatsapp":
      return "WhatsApp (Baileys)";
    case "whatsapp_oficial":
      return "WhatsApp Oficial (Meta)";
    case "facebook":
      return "Facebook";
    case "instagram":
      return "Instagram";
    default:
      return channel || "";
  }
};

const Connections = () => {
  const classes = useStyles();
  const theme = useTheme();
  const aerosModal = useAerosModalStyles();

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState("whatsapp");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    confirmLabel: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
  const [planConfig, setPlanConfig] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  // Conexao com sincronizacao de templates em andamento (trava so aquela
  // linha) e resultado da ultima sincronizacao (alimenta o dialogo de modelos).
  const [syncingTemplatesId, setSyncingTemplatesId] = useState(null);
  const [templatesSync, setTemplatesSync] = useState(null);
  const [sourceConnection, setSourceConnection] = useState("");
  const [targetConnection, setTargetConnection] = useState("");
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [transferProgressModalOpen, setTransferProgressModalOpen] = useState(false);
  const [transferProgress, setTransferProgress] = useState({ current: 0, total: 0, percentage: 0 });
  // A listagem de whatsApps vem do socket (useWhatsApps); a rota de reverificação
  // de webhook grava statusWebhook no banco mas não emite evento de socket.
  // Guardamos aqui um override local para o selo sumir sem esperar o próximo
  // evento (ou reload da página).
  const [webhookStatusOverrides, setWebhookStatusOverrides] = useState({});

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  // "Mensagens hoje" (stat card) — soma enviadas+recebidas de hoje via o mesmo
  // hook do Dashboard (GET /messages-allMe). O backend
  // (ListMessagesServiceAll) espera yyyy-MM-dd e concatena 00:00:00/23:59:59.
  const todayIso = format(new Date(), "yyyy-MM-dd");
  const { count: sentToday } = useMessages({
    fromMe: true,
    dateStart: todayIso,
    dateEnd: todayIso,
  });
  const { count: receivedToday } = useMessages({
    fromMe: false,
    dateStart: todayIso,
    dateEnd: todayIso,
  });
  const messagesToday = (Number(sentToday) || 0) + (Number(receivedToday) || 0);

  // "N empresas na plataforma" no subtítulo: informação de super admin, então
  // a requisição só sai para quem é super — `/companies/list` responderia 403
  // para os demais e sujaria o console com um erro esperado.
  const [companyCount, setCompanyCount] = useState(null);

  useEffect(() => {
    if (!user?.super) return;
    let ativo = true;
    (async () => {
      try {
        const { data } = await api.get("/companies/list");
        if (ativo) setCompanyCount(Array.isArray(data) ? data.length : null);
      } catch (err) {
        // Falha silenciosa: o subtítulo perde a parte das empresas, mas a
        // tela — que existe para gerir conexões — continua de pé.
        if (ativo) setCompanyCount(null);
      }
    })();
    return () => {
      ativo = false;
    };
  }, [user]);

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    socket.on(`importMessages-${user.companyId}`, (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    });

    socket.on(`transferTickets-${user.companyId}`, (data) => {
      if (data.action === "progress") {
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: Math.round((data.current / data.total) * 100)
        });
      }
      if (data.action === "completed") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.success(`Transferência concluída! ${data.transferred} tickets transferidos com sucesso.`);
        handleCloseTransferModal();
      }
      if (data.action === "error") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.error("Erro na transferência de tickets.");
      }
    });

    /* return () => {
      socket.disconnect();
    }; */
  }, [whatsApps]);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    try {
      await api.post(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    try {
      await api.put(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenWhatsAppModal = (channel) => {
    setChannel(channel)
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setChannel(whatsApp.channel)
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsApp) => {
    // Antes: disparava o GET e nada acontecia na tela — nem loading, nem
    // sucesso, nem erro. Agora o backend devolve o resumo (sincronizados,
    // removidos e a lista) e o toast abre o dialogo com os modelos.
    setSyncingTemplatesId(whatsApp.id);
    try {
      const { data } = await api.get(`/whatsapp/sync-templates/${whatsApp.id}`);
      const resultado = { ...data, nomeConexao: whatsApp.name };

      const resumo =
        `${data.sincronizados} modelo(s) sincronizado(s)` +
        (data.removidos > 0
          ? `, ${data.removidos} removido(s) por nao existirem mais na Meta`
          : "");

      toast.success(`${resumo}. Clique para ver os modelos.`, {
        autoClose: 8000,
        onClick: () => setTemplatesSync(resultado),
      });
    } catch (err) {
      toastError(err);
    } finally {
      setSyncingTemplatesId(null);
    }
  };

  const handleCopyWebhook = (url) => {
    navigator.clipboard.writeText(url); // Copia o token para a área de transferência
  };

  const handleReverificarWebhook = async (whatsApp) => {
    try {
      const { data } = await api.get(`/whatsapp/oficial/${whatsApp.id}/webhook-status`);
      setWebhookStatusOverrides((prev) => ({
        ...prev,
        [whatsApp.id]: data.inscrito ? "verified" : "unverified",
      }));
      toast.success(
        data.inscrito
          ? i18n.t("whatsappOficialWizard.webhook.verificado")
          : i18n.t("whatsappOficialWizard.webhook.naoVerificado")
      );
    } catch (err) {
      toastError(err);
    }
  };

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    // O mockup nomeia a conexão no título ("Excluir a conexão Financeiro?"):
    // sem o nome, quem tem várias conexões não sabe qual vai perder.
    const nome =
      whatsApps.find((w) => w.id === whatsAppId)?.name ||
      i18n.t("connections.title");

    if (action === "disconnect") {
      setConfirmModalInfo({
        action,
        title: i18n.t("aeros.connections.confirm.disconnectTitle", { name: nome }),
        message: i18n.t("aeros.connections.confirm.disconnectMessage"),
        confirmLabel: i18n.t("aeros.connections.confirm.disconnectAction"),
        whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action,
        title: i18n.t("aeros.connections.confirm.deleteTitle", { name: nome }),
        message: i18n.t("aeros.connections.confirm.deleteMessage"),
        confirmLabel: i18n.t("aeros.connections.confirm.deleteAction"),
        whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action,
        title: i18n.t("aeros.connections.confirm.closedImportedTitle", {
          name: nome,
        }),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        confirmLabel: i18n.t("aeros.connections.confirm.closedImportedAction"),
        whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }


    setConfirmModalInfo(confirmationModalInitialState);
  };


  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          className={classes.sessionButton}
          onClick={() => {
            handleOpenConfirmationModal("closedImported", whatsApp.id);
          }}
        >
          {i18n.t("connections.buttons.closedImported")}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                className={classes.sessionButton}
                size="small"
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.buttonProgress}
                  />
                }
                variant="outlined"
                color="primary"
              >
                {i18n.t("connections.buttons.preparing")}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    return (
      <>
        {whatsApp.channel === "whatsapp" && whatsApp.status === "qrcode" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <Button
                size="small"
                variant="contained"
                color="primary"
                className={classes.sessionButton}
                onClick={() => handleOpenQrModal(whatsApp)}
              >
                {i18n.t("connections.buttons.qrcode")}
              </Button>
            )}
          />
        )}
        {whatsApp.channel === "whatsapp" && whatsApp.status === "DISCONNECTED" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  className={classes.sessionButton}
                  onClick={() => handleStartWhatsAppSession(whatsApp.id)}
                >
                  {i18n.t("connections.buttons.tryAgain")}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className={`${classes.sessionButton} ${classes.sessionButtonGhost}`}
                  onClick={() => handleRequestNewQrCode(whatsApp.id)}
                >
                  {i18n.t("connections.buttons.newQr")}
                </Button>
              </>
            )}
          />
        )}
        {(whatsApp.channel === "whatsapp" && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <>
                  <Button
                    size="small"
                    variant="outlined"
                    className={`${classes.sessionButton} ${classes.sessionButtonDestructive}`}
                    onClick={() => {
                      handleOpenConfirmationModal("disconnect", whatsApp.id);
                    }}
                  >
                    {i18n.t("connections.buttons.disconnect")}
                  </Button>

                  {renderImportButton(whatsApp)}
                </>
              )}
            />
          )}
        {(whatsApp.channel === "whatsapp" && whatsApp.status === "OPENING") && (
          <Button
            size="small"
            variant="outlined"
            disabled
            color="default"
            className={`${classes.sessionButton} ${classes.sessionButtonGhost}`}
          >
            {i18n.t("connections.buttons.connecting")}
          </Button>
        )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    // Na conexão oficial o cadastro é síncrono: ou volta CONNECTED, ou falhou.
    // OPENING/DISCONNECTED aqui significam sempre erro de registro na API Oficial —
    // renderizar spinner nesse caso deixava a linha "carregando" para sempre.
    const isOficialError =
      whatsApp.channel === "whatsapp_oficial" &&
      (whatsApp.status === "OPENING" || whatsApp.status === "DISCONNECTED");

    const selo = seloContaMeta(whatsApp);

    const statusWebhook =
      webhookStatusOverrides[whatsApp.id] ?? whatsApp.statusWebhook;

    const webhookBadge = whatsApp.channel === "whatsapp_oficial" &&
      statusWebhook !== "verified" && (
        <Chip
          size="small"
          icon={<WebhookIcon style={{ color: AEROS.warning, fontSize: 16 }} />}
          style={{
            backgroundColor: "rgba(251,191,36,0.1)",
            border: "1px solid rgba(251,191,36,0.3)",
            color: stateText(theme, AEROS.warning, "warning"),
          }}
          label={i18n.t("connections.webhookNaoConfirmado")}
          title={i18n.t("connections.reverificarWebhook")}
          onClick={() => handleReverificarWebhook(whatsApp)}
        />
      );

    // Pill do mockup: dot 6×6 + label 11/600 sobre cor@10% — Conectado verde,
    // QR Code/abrindo âmbar, desconectado/erro vermelho. Tooltips preservados.
    let pillVariant = classes.statusPillError;
    let pillLabel = "Desconectado";
    let tooltip = {
      title: i18n.t("connections.toolTips.disconnected.title"),
      content: i18n.t("connections.toolTips.disconnected.content"),
    };

    if (isOficialError) {
      pillLabel = "Erro";
      tooltip = {
        title: i18n.t("connections.toolTips.oficialError.title"),
        content: i18n.t("connections.toolTips.oficialError.content"),
      };
    } else if (whatsApp.status === "CONNECTED") {
      pillVariant = classes.statusPillSuccess;
      pillLabel = "Conectado";
      tooltip = { title: i18n.t("connections.toolTips.connected.title") };
    } else if (whatsApp.status === "qrcode") {
      pillVariant = classes.statusPillWarning;
      pillLabel = "QR Code";
      tooltip = {
        title: i18n.t("connections.toolTips.qrcode.title"),
        content: i18n.t("connections.toolTips.qrcode.content"),
      };
    } else if (whatsApp.status === "OPENING") {
      pillVariant = classes.statusPillWarning;
      pillLabel = "Conectando";
      tooltip = { title: i18n.t("connections.buttons.connecting") };
    } else if (whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") {
      pillLabel = "Sem conexão";
      tooltip = {
        title: i18n.t("connections.toolTips.timeout.title"),
        content: i18n.t("connections.toolTips.timeout.content"),
      };
    }

    return (
      <div className={classes.statusCellInner}>
        <CustomToolTip title={tooltip.title} content={tooltip.content}>
          <span className={`${classes.statusPill} ${pillVariant}`}>
            <span className={classes.statusDot} />
            {pillLabel}
            {whatsApp.status === "OPENING" && !isOficialError && (
              <CircularProgress size={11} color="inherit" />
            )}
          </span>
        </CustomToolTip>
        {webhookBadge}
        {selo && (
          <>
            <span
              className={`${classes.statusPill} ${classes.statusPillWarning} ${classes.contaMetaSelo}`}
              title={`${selo.titulo}${selo.acao ? ` — ${selo.acao}` : ""}`}
              data-testid="selo-conta-meta"
            >
              {selo.label}
            </span>
            {selo.link && (
              <a className={classes.contaMetaLink} href={selo.link} target="_blank" rel="noopener noreferrer">
                {i18n.t("metaErrors.fixAt")}
              </a>
            )}
            <BotaoJaRegularizei whatsappId={whatsApp.id} user={user} />
          </>
        )}
      </div>
    );
  };

  const restartWhatsapps = async () => {

    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  }

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection("");
    setTargetConnection("");
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0 });
  };

  const handleTransferTickets = async () => {
    if (!sourceConnection || !targetConnection) {
      toast.error("Selecione as conexões de origem e destino");
      return;
    }

    if (sourceConnection === targetConnection) {
      toast.error("As conexões de origem e destino devem ser diferentes");
      return;
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: sourceConnection,
        targetConnectionId: targetConnection
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({ current: 0, total: response.data.totalTickets, percentage: 0 });
      } else {
        toast.success(`Tickets transferidos com sucesso! ${response.data.transferred || 0} tickets transferidos.`);
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
  };

  const handleConfirmTransferDone = () => {
    setPreDeleteModalOpen(false);
    handleOpenConfirmationModal("delete", whatsAppToDelete);
    setWhatsAppToDelete(null);
  };

  return (
    <MainContainer>
      <AerosConfirmModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleSubmitConfirmationModal}
        icon={
          confirmModalInfo.action === "delete" ? (
            <DeleteForeverIcon />
          ) : (
            <LinkOffIcon />
          )
        }
        tone={confirmModalInfo.action === "closedImported" ? "warning" : "danger"}
        title={confirmModalInfo.title}
        description={confirmModalInfo.message}
        confirmLabel={confirmModalInfo.confirmLabel}
      />
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <WhatsAppOficialWizard
        open={wizardOpen}
        onClose={() => setWizardOpen(false)}
        onConcluido={(whatsapp) => {
          setWizardOpen(false);
          if (whatsapp) handleEditWhatsApp(whatsapp);
        }}
      />
      <AerosDialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        title={i18n.t("aeros.connections.transfer.title")}
        width={560}
        onSubmit={handleTransferTickets}
        submitLabel={i18n.t("aeros.connections.transfer.action")}
      >
        <div className={classes.modalText}>
          {i18n.t("aeros.connections.transfer.desc")}
        </div>
        <div className={classes.transferRow}>
          <div>
            <label className={aerosModal.fieldLabel}>
              {i18n.t("aeros.connections.transfer.source")}
            </label>
            <FormControl fullWidth variant="outlined" className={aerosModal.input}>
              <Select
                value={sourceConnection}
                onChange={(e) => setSourceConnection(e.target.value)}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <ArrowForwardIcon className={classes.transferArrow} />

          <div>
            <label className={aerosModal.fieldLabel}>
              {i18n.t("aeros.connections.transfer.target")}
            </label>
            <FormControl fullWidth variant="outlined" className={aerosModal.input}>
              <Select
                value={targetConnection}
                onChange={(e) => setTargetConnection(e.target.value)}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </AerosDialog>
      <AerosDialog
        open={transferProgressModalOpen}
        onClose={handleCloseTransferProgressModal}
        title={i18n.t("aeros.connections.transfer.progressTitle")}
        width={420}
        footer={null}
        disableEscapeKeyDown
      >
        <div className={classes.progressBox}>
          <Box position="relative" display="inline-flex">
            <CircularProgress
              variant="determinate"
              value={transferProgress.percentage}
              size={80}
              thickness={4}
            />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <span className={classes.progressPct}>
                {transferProgress.percentage}%
              </span>
            </Box>
          </Box>
          <div className={classes.progressCount}>
            {i18n.t("aeros.connections.transfer.progressCount", {
              current: transferProgress.current,
              total: transferProgress.total,
            })}
          </div>
          <div className={classes.modalText}>
            {i18n.t("aeros.connections.transfer.progressWait")}
          </div>
        </div>
      </AerosDialog>
       {/* Modelos retornados pela ultima sincronizacao de templates da Meta;
           aberto pelo clique no toast de sucesso. */}
      <AerosDialog
        open={Boolean(templatesSync)}
        onClose={() => setTemplatesSync(null)}
        title={`${i18n.t("aeros.connections.templates.title")}${
          templatesSync?.nomeConexao ? ` — ${templatesSync.nomeConexao}` : ""
        }`}
        subtitle={[
          i18n.t("aeros.connections.templates.summary", {
            count: templatesSync?.sincronizados || 0,
          }),
          templatesSync?.removidos > 0 &&
            i18n.t("aeros.connections.templates.removed", {
              count: templatesSync.removidos,
            }),
        ]
          .filter(Boolean)
          .join(" · ")}
        width={620}
        footer={null}
      >
        {/* TableContainer: em tela estreita a tabela rola na horizontal dentro do
            proprio container, em vez de empurrar a pagina inteira para o lado. */}
        <TableContainer>
          <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{i18n.t("aeros.connections.templates.name")}</TableCell>
              <TableCell>
                {i18n.t("aeros.connections.templates.category")}
              </TableCell>
              <TableCell>
                {i18n.t("aeros.connections.templates.language")}
              </TableCell>
              <TableCell>
                {i18n.t("aeros.connections.templates.status")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(templatesSync?.templates || []).map((template) => (
              <TableRow key={template.metaID}>
                <TableCell>{template.nome}</TableCell>
                <TableCell>{template.categoria}</TableCell>
                <TableCell>{template.idioma}</TableCell>
                <TableCell>
                  <span
                    className={classes.statusPill}
                    style={{
                      color: stateText(
                        theme,
                        template.status === "APPROVED"
                          ? AEROS.success
                          : AEROS.warning,
                        template.status === "APPROVED" ? "success" : "warning"
                      ),
                      backgroundColor: alpha(
                        template.status === "APPROVED"
                          ? AEROS.success
                          : AEROS.warning,
                        0.12
                      ),
                    }}
                  >
                    {template.status}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          </Table>
        </TableContainer>
      </AerosDialog>
      <AerosConfirmModal
        open={preDeleteModalOpen}
        onClose={handleClosePreDeleteModal}
        onConfirm={handleConfirmTransferDone}
        icon={<SwapHorizIcon />}
        tone="warning"
        title={i18n.t("aeros.connections.transfer.preDeleteTitle")}
        description={i18n.t("aeros.connections.transfer.preDeleteMessage")}
        confirmLabel={i18n.t("aeros.connections.transfer.preDeleteConfirm")}
        cancelLabel={i18n.t("aeros.connections.transfer.preDeleteCancel")}
      />
      {user.profile === "user" && user.allowConnections === "disabled" ?
        <ForbiddenPage />
        :
        <>
          <div className={classes.pageHeader}>
            <div>
              <Typography component="div" className={classes.pageTitle}>
                {i18n.t("connections.title")}{" "}
                <span className={classes.pageTitleCount}>
                  · {whatsApps.length}
                </span>
              </Typography>
              <Typography component="div" className={classes.pageSubtitle}>
                {headerSubtitle(whatsApps, companyCount ?? undefined)}
              </Typography>
            </div>
            <div className={classes.headerActions}>
              {user?.super && (
                <Button
                  variant="outlined"
                  className={`${classes.ghostButton} ${classes.superButton}`}
                  startIcon={<AdminPanelSettingsIcon />}
                  onClick={() => history.push("/allConnections")}
                >
                  {i18n.t("aeros.connections.manage")}
                  <span className={classes.superBadge}>
                    {i18n.t("aeros.connections.super")}
                  </span>
                </Button>
              )}
              <Button
                variant="outlined"
                className={classes.ghostButton}
                startIcon={<SwapHoriz />}
                onClick={handleOpenTransferModal}
              >
                {i18n.t("connections.transferTickets")}
              </Button>

              <Button
                variant="outlined"
                className={classes.ghostButton}
                startIcon={<Replay />}
                onClick={restartWhatsapps}
              >
                {i18n.t("connections.restartConnections")}
              </Button>

              <Button
                variant="outlined"
                className={classes.ghostButton}
                startIcon={<HeadsetMic />}
                onClick={() => openInNewTab(`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`)}
              >
                {i18n.t("connections.callSupport")}
              </Button>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform="connections-page:addConnection"
                      yes={() => (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.gradientButton}
                            startIcon={<Add />}
                            endIcon={<ExpandMore />}
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t("connections.newConnection")}
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            {/* WHATSAPP */}
                            <MenuItem
                              disabled={planConfig?.plan?.useWhatsapp ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal();
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp
                            </MenuItem>
                            {/* WHATSAPP OFICIAL */}
                            <MenuItem
                              disabled={planConfig?.plan?.useWhatsappOfficial ? false : true}
                              onClick={() => {
                                setWizardOpen(true);
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp Oficial
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={planConfig?.plan?.useFacebook ? false : true}
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#3b5998",
                                    }}
                                  />
                                  Facebook
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={planConfig?.plan?.useInstagram ? false : true}
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#e1306c",
                                    }}
                                  />
                                  Instagram
                                </MenuItem>
                              )}
                            />
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </div>
          </div>

          {
            statusImport?.all ? (
              <>
                <div style={{ margin: "auto", marginBottom: 12 }}>
                  <Card className={classes.root}>
                    <CardContent className={classes.content}>
                      <Typography component="h5" variant="h5">

                        {statusImport?.this === -1 ? i18n.t("connections.buttons.preparing") : i18n.t("connections.buttons.importing")}

                      </Typography>
                      {statusImport?.this === -1 ?
                        <Typography component="h6" variant="h6" align="center">

                          <CircularProgress
                            size={24}
                          />

                        </Typography>
                        :
                        <>
                          <Typography component="h6" variant="h6" align="center">
                            {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                          </Typography>
                          <Typography align="center">
                            <CircularProgressWithLabel
                              style={{ margin: "auto" }}
                              value={(statusImport?.this / statusImport?.all) * 100}
                            />
                          </Typography>
                        </>
                      }
                    </CardContent>
                  </Card>
                </div>
              </>
            ) : null
          }

          <div className={classes.pageBody}>
            <div className={classes.tableCard}>
              <div className={classes.tableHeadRow}>
                <div className={`${classes.tableCell} ${classes.cellCenter}`}>{i18n.t("connections.table.channel")}</div>
                <div className={`${classes.tableCell} ${classes.cellCenter}`}>{i18n.t("connections.table.color")}</div>
                <div className={classes.tableCell}>{i18n.t("connections.table.name")}</div>
                <div className={classes.tableCell}>{i18n.t("connections.table.number")}</div>
                <div className={classes.tableCell}>{i18n.t("connections.table.status")}</div>
                <div className={classes.tableCell}>{i18n.t("connections.table.session")}</div>
                <div className={classes.tableCell}>{i18n.t("connections.table.lastUpdate")}</div>
                <div className={`${classes.tableCell} ${classes.cellCenter}`}>{i18n.t("connections.table.default")}</div>
                <div className={`${classes.tableCell} ${classes.cellActionsHead}`}>
                  <Can
                    role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                    perform="connections-page:addConnection"
                    yes={() => <>{i18n.t("connections.table.actions")}</>}
                  />
                </div>
              </div>
              {loading ? (
                <div className={classes.loadingRow}>
                  <CircularProgress size={24} />
                </div>
              ) : (
                <>
                  {whatsApps?.length > 0 &&
                    whatsApps.map((whatsApp) => (
                      <div className={classes.tableRow} key={whatsApp.id}>
                        <div className={`${classes.tableCell} ${classes.cellCenter}`}>{IconChannel(whatsApp.channel)}</div>
                        <div className={`${classes.tableCell} ${classes.cellCenter}`}>
                          <span
                            className={classes.colorSwatch}
                            style={{ backgroundColor: whatsApp.color }}
                          />
                        </div>
                        <div className={`${classes.tableCell} ${classes.nameCell}`}>
                          {whatsApp.name}
                          <div className={classes.nameSub}>
                            {channelSublabel(whatsApp.channel)}
                          </div>
                        </div>
                        <div className={`${classes.tableCell} ${classes.numberCell}`}>
                          {whatsApp.channel === 'whatsapp' && whatsApp.number
                            ? <>{formatSerializedId(whatsApp.number)}</>
                            : whatsApp.channel === 'whatsapp_oficial' && whatsApp.phone_number
                                ? <>{formatSerializedId(whatsApp.phone_number)}</>
                                : "-"}
                        </div>
                        <div className={classes.tableCell}>{renderStatusToolTips(whatsApp)}</div>
                        <div className={`${classes.tableCell} ${classes.cellSession}`}>{renderActionButtons(whatsApp)}</div>
                        <div className={`${classes.tableCell} ${classes.updatedCell}`}>{format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}</div>
                        <div className={`${classes.tableCell} ${classes.cellCenter}`}>
                          {whatsApp.isDefault && (
                            <CheckCircle
                              className={classes.defaultCheck}
                              style={{ fontSize: 19 }}
                            />
                          )}
                        </div>
                        <div className={`${classes.tableCell} ${classes.cellActions}`}>
                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <>
                                <IconButton
                                  size="small"
                                  className={classes.rowActionButton}
                                  onClick={() => handleEditWhatsApp(whatsApp)}
                                  aria-label="Editar conexão"
                                >
                                  <Edit />
                                </IconButton>

                                <IconButton
                                  size="small"
                                  className={classes.rowActionButton}
                                  onClick={(e) => {
                                    handleOpenPreDeleteModal(whatsApp.id);
                                  }}
                                  aria-label="Excluir conexão"
                                >
                                  <DeleteOutline />
                                </IconButton>
                                {whatsApp.channel === "whatsapp_oficial" && (
                                  <>
                                    <Tooltip title="Sincronizar templates">
                                      <span>
                                        <IconButton
                                          size="small"
                                          className={classes.rowActionButton}
                                          aria-label="sync-templates"
                                          disabled={syncingTemplatesId === whatsApp.id}
                                          onClick={(e) => {
                                            handleSyncTemplates(whatsApp);
                                          }}
                                        >
                                          {syncingTemplatesId === whatsApp.id ? (
                                            <CircularProgress size={18} />
                                          ) : (
                                            <Sync />
                                          )}
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    <Tooltip title="Copiar webhook para Meta">
                                      <IconButton
                                        size="small"
                                        className={classes.rowActionButton}
                                        aria-label="copy-webhook"
                                        onClick={(e) => {
                                          handleCopyWebhook(whatsApp.waba_webhook);
                                        }}
                                      >
                                        <WebhookIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </>
                            )}
                          />
                        </div>
                      </div>
                    ))}
                </>
              )}
            </div>

            <div className={classes.summaryCardsWrapper}>
              <Paper className={classes.summaryCard}>
                <div className={`${classes.summaryIcon} ${classes.summaryIconSuccess}`}>
                  <SignalCellular4Bar />
                </div>
                <div>
                  <Typography className={classes.summaryValue}>
                    {whatsApps.filter((w) => w.status === "CONNECTED").length}/{whatsApps.length}
                  </Typography>
                  <Typography className={classes.summaryLabel}>Conexões ativas</Typography>
                </div>
              </Paper>
              <Paper className={classes.summaryCard}>
                <div className={`${classes.summaryIcon} ${classes.summaryIconWarning}`}>
                  <CropFree />
                </div>
                <div>
                  <Typography className={classes.summaryValue}>
                    {whatsApps.filter((w) => w.status === "qrcode" || w.status === "OPENING").length}
                  </Typography>
                  <Typography className={classes.summaryLabel}>Aguardando QR Code</Typography>
                </div>
              </Paper>
              <Paper className={classes.summaryCard}>
                <div className={`${classes.summaryIcon} ${classes.summaryIconPurple}`}>
                  <Forum />
                </div>
                <div>
                  <Typography className={classes.summaryValue}>
                    {messagesToday.toLocaleString("pt-BR")}
                  </Typography>
                  <Typography className={classes.summaryLabel}>Mensagens hoje</Typography>
                </div>
              </Paper>
            </div>
          </div>
        </>
      }
    </MainContainer >

  );
};

export default Connections;